import { installConsoleDebugGuard } from './consoleDebug';

installConsoleDebugGuard();
